import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { patchSponsor } from "../../store/sponsor/actions";
export var useSponsorPatch = function (trigger, body) {
    var dispatch = useDispatch();
    var _a = useSelector(function (state) { return ({
        responsePatchSponsor: state.Sponsor.responsePatchSponsor,
        errorPatchSponsor: state.Sponsor.errorPatchSponsor,
        loadingPatchSponsor: state.Sponsor.loadingPatchSponsor,
    }); }), responsePatchSponsor = _a.responsePatchSponsor, errorPatchSponsor = _a.errorPatchSponsor, loadingPatchSponsor = _a.loadingPatchSponsor;
    useEffect(function () {
        if (trigger) {
            dispatch(patchSponsor({
                clientId: body.clientId,
                name: body.name,
                code: body.code,
            }, body.id));
        }
    }, [trigger]);
    return {
        responsePatchSponsor: responsePatchSponsor,
        errorPatchSponsor: errorPatchSponsor,
        loadingPatchSponsor: loadingPatchSponsor,
    };
};
